module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_6.9aee5f05.jpg";